/**************************************************
 * Nombre:       Formulario_Lista_Productos
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {CircularProgress, Grid, Typography} from "@mui/material";
import {useEffect, useState} from "react";
import {formatoMoneda} from "../../Utilidades/formatoMoneda";
import {theme} from "../../Tema";
import {obtenerDaneCode} from "../../Modulo_envios/Funciones/obtenerDaneCode";
import {obtenerPesoTotalEnKilos} from "../../Modulo_envios/Funciones/obtenerPesoTotalEnKilos";
import {obtenerDimencionTotal} from "../../Modulo_envios/Funciones/obtenerDimencionTotal";
import {obtenerValorTotal} from "../../Modulo_envios/Funciones/obtenerValorTotal";
import {obtenerCotizacion} from "../../Modulo_envios/Funciones/obtenerCotizacion";
import {BODEGA} from "../../Modulo_envios/Constantes_Bodega";
import SeleccionadorOpciones from "../../Modulo_envios/Componentes/SeleccionadorOpciones";
import {escogerCotizacionEconomica} from "../../Modulo_envios/Funciones/escogerCotizacionEconomica";
import {sacarPorcentaje} from "../Utilidades/sacarPorcentaje";
import {obtenerTotalProductos} from "../Utilidades/obtenerTotalProductos";
import {VALORENVIOGRATIS} from "../../Constantes";
import caja from '../../Recursos/caja.svg'
import {where} from "firebase/firestore";
import {obtenerColWheres} from "../../Servicios/BD/obtenerColWheres";
import {valorMenosDescuento} from "../../Utilidades/valorMenosDescuento";
import {obtenerValorEnvio} from "../../CodCliente/obtenerValorEnvio";

const Formulario_Lista_Productos = ({...props}) => {
    const [cotizaciones, setCotizaciones] = useState([])
    const [cargando, setCargando] = useState(false)
    const [idCotizacion, setIdCotizacion] = useState('')
    const [valorEnvio, setValorEnvio] = useState(0)
    const [valorProductos, setValorProductos] = useState(0)
    const [envioGratis, setEnvioGratis] = useState(false)
    const [cotizacionEscogida, setCotizacionEscogida] = useState({})
    const [valido, setValido] = useState(false)
    const [codDescuento, setCodDescuento] = useState('')
    const [yaCotizo, setYaCotizo] = useState(false)


    const cambiarCotizacion = (idRate) => {
        setIdCotizacion(idRate)
        props.props.setValue('idRate', parseInt(idRate))
        let arrCot = cotizaciones.filter((it) => it.idRate === parseInt(idRate))
        setValorEnvio(obtenerValorEnvio(arrCot[0]))
        props.props.setValue('valorEnvio', obtenerValorEnvio(arrCot[0]))
        setCotizacionEscogida(arrCot[0])

    }

    const isCodigoValido = async (correo, cc) => {

        //si correo esta en suscriptores
        let wc = [where('correo', '==', correo)]
        let dox = await obtenerColWheres({col: 'suscriptores', wheres: wc})
        if (dox.data && dox.data.length > 0) {

            let suscriptor = dox.data[0]
            if (suscriptor.ciudad) {
                return false
            } else {
                return true
            }


        }

        return false

    }

    const obtnenerValorCancelar = () => {

        let valor = valorProductos + valorEnvio

        if (valido) {
            valor -= valorMenosDescuento({
                valor: valorProductos,
                descuento: 10
            })
        }

        return valor

    }


    useEffect(() => {
        let entidad = props.props.getValues()
        let productos = entidad.productos
        let ciudad = entidad.ciudad
        let correo = entidad.correo
        let cc = entidad.cc
        let departamento = entidad.departamento
        let codDescuento = entidad.codDescuento
        let codigoSIU = obtenerDaneCode(departamento, ciudad)
        let pesoTotal = obtenerPesoTotalEnKilos(productos)
        let dimencionTotal = obtenerDimencionTotal(productos)
        let valorTotal = obtenerValorTotal(productos)
        setValorProductos(valorTotal)

        let porcentaje = sacarPorcentaje({
            valor: obtenerTotalProductos(productos),
            maximo: VALORENVIOGRATIS
        })

        if (porcentaje >= 100) {
            setEnvioGratis(true)
        }

        props.props.setValue('pesoTotal', pesoTotal)
        props.props.setValue('alto', dimencionTotal.alto)
        props.props.setValue('ancho', dimencionTotal.ancho)
        props.props.setValue('fondo', dimencionTotal.fondo)
        props.props.setValue('codigoDane', codigoSIU * 1000)


        setCargando(true)
        obtenerCotizacion({
            dimencionesTotal: dimencionTotal,
            valorTotal: valorTotal,
            bodega: BODEGA,
            pesoTotal: pesoTotal,
            codigoDane: codigoSIU,
            direccionEnvio: entidad.direccion
        }).then((dox) => {
            setCotizaciones(dox.data)
            setIdCotizacion(escogerCotizacionEconomica(dox.data).idRate)
            props.props.setValue('idRate', escogerCotizacionEconomica(dox.data).idRate)
            props.props.setValue('valorEnvio', obtenerValorEnvio(escogerCotizacionEconomica(dox.data)))
            setValorEnvio(obtenerValorEnvio(escogerCotizacionEconomica(dox.data)))
          //  console.log(escogerCotizacionEconomica(dox.data))
            setCotizacionEscogida(escogerCotizacionEconomica(dox.data))
            setCargando(false)
            setYaCotizo(true)
        })


        setCodDescuento(codDescuento)
        //Verificamos codigo de descuento
        if (codDescuento) {

            isCodigoValido(correo, cc).then((dox) => {
                if (dox) {
                    props.props.setValue('descuento', true)
                    setValido(true)
                }
            })

        }


    }, []);

    return (

        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            spacing={2}
        >

            <Grid container size={{xs: 12, sm: 12, md: 12}}>
                {cargando && cotizaciones.length === 0 ?
                    <Grid
                        container
                        direction="row"
                        justifyContent="center"
                        alignItems="flex-start"
                        size={12}
                    >

                        <Grid item container size={12} sx={{justifyContent: 'center', marginTop: 8}}>
                            <Typography>Consultando tiempos de Envío</Typography>
                        </Grid>

                        <Grid item container size={12}
                              sx={{justifyContent: 'center', marginTop: 2, marginBottom: 8}}>
                            <CircularProgress/>
                        </Grid>

                    </Grid>

                    :

                    envioGratis ?

                        <Grid
                            container
                            direction="row"
                            justifyContent="center"
                            alignItems="flex-start"
                            size={12}
                        >

                            <Grid item container size={12} sx={{justifyContent: 'center', marginTop: 4}}>
                                <Typography sx={{color: '#000', fontSize: 32, fontWeight: 800}}>Envio
                                    Gratis!!</Typography>
                            </Grid>

                            <Grid item container size={12} sx={{justifyContent: 'center', marginTop: -2}}>
                                <Typography sx={{color: '#00000080', fontSize: 18, fontWeight: 400}}>
                                    {`Tiempo de llegada: ${cotizacionEscogida.deliveryDays} dias`}
                                </Typography>
                            </Grid>

                            <Grid item container size={12} sx={{justifyContent: 'center', marginTop: -3}}>
                                <Typography sx={{color: '#00000080', fontSize: 14, fontWeight: 400}}>
                                    {`Empresa de envio: ${cotizacionEscogida.carrier}`}
                                </Typography>
                            </Grid>

                            <Grid item container size={12}
                                  sx={{justifyContent: 'center', marginTop: 2, marginBottom: 0}}>
                                <img src={caja} width={150} height={'auto'}/>
                            </Grid>


                        </Grid>

                        :


                        <SeleccionadorOpciones opciones={cotizaciones} idCotizacion={idCotizacion}
                                               setIdCotizacion={cambiarCotizacion} yaCotizo={yaCotizo}/>

                }
            </Grid>

            {codDescuento &&
                <Grid container size={{xs: 12, sm: 12, md: 12}} justifyContent={'flex-start'} sx={{mt: 2, pl: 2}}>
                    <Typography sx={{
                        fontSize: 14,
                        fontWeight: 600,
                    }}>{`${codDescuento}`} <span
                        style={{fontWeight: 300}}>{valido ? 'Aplicado' : 'Invalido o ya canjeado'}</span> </Typography>
                </Grid>
            }

            {envioGratis ?


                <Grid container size={{xs: 12, sm: 12, md: 12}} justifyContent={'flex-end'} sx={{mt: 2, pr: 2}}>
                    <Typography sx={{
                        fontSize: 20,
                        fontWeight: 700,
                        color: theme.palette.primary.main,
                        borderTop: 1,
                        pt: 1
                    }}>{`Total Compra : ${formatoMoneda(valorProductos)}`}</Typography>
                </Grid>


                :


                <>
                    <Grid container size={{xs: 12, sm: 12, md: 12}} justifyContent={'flex-end'} sx={{mt: 1, pr: 2}}>
                        <Typography sx={{
                            fontSize: 14,
                            fontWeight: 600,
                            color: theme.palette.primary.main
                        }}>{`Valor Envio : ${formatoMoneda(valorEnvio)}`}</Typography>
                    </Grid>


                    <Grid container size={{xs: 12, sm: 12, md: 12}} justifyContent={'flex-end'} sx={{mt: -2, pr: 2}}>
                        <Typography sx={{
                            fontSize: 14,
                            fontWeight: 600,
                            color: theme.palette.primary.main
                        }}>{`Valor Compra : ${formatoMoneda(valorProductos)}`}</Typography>
                    </Grid>

                    {valido &&
                        <Grid container size={{xs: 12, sm: 12, md: 12}} justifyContent={'flex-end'}
                              sx={{mt: -2, pr: 2}}>
                            <Typography sx={{
                                fontSize: 14,
                                fontWeight: 600,
                                color: theme.palette.primary.main
                            }}>{`Descuento 10% Primera Compra: -${formatoMoneda(valorMenosDescuento({
                                valor: valorProductos,
                                descuento: 10
                            }))}`}</Typography>
                        </Grid>
                    }


                    <Grid container size={{xs: 12, sm: 12, md: 12}} justifyContent={'flex-end'} sx={{mt: -1, pr: 2}}>
                        <Typography sx={{
                            fontSize: 20,
                            fontWeight: 700,
                            color: theme.palette.primary.main,
                            borderTop: 1,
                            pt: 1
                        }}>{`Total Pedido : ${formatoMoneda(obtnenerValorCancelar())}`}</Typography>
                    </Grid>

                </>


            }


        </Grid>


    )

}
export default Formulario_Lista_Productos